// import { ctrl as outbound_ioc } from "./outbound_ioc";

export = function (ngModule) {
    ngModule.controller('customIOCController', require('./custom_ioc'));
    ngModule.controller('iocEventsDrilldownController', require('./ioc_events_drilldown'));
    ngModule.controller('inboundIocController', require('./inbound_ioc'));
    ngModule.controller('outboundIocController', require('./outbound_ioc'));
    ngModule.controller('lateralIocController', require('./lateral_ioc'));
    ngModule.controller('iocFeedsController', require('./ioc_feeds'));
    ngModule.controller('archiveController', require('./archive'));
    ngModule.controller('whitelistController', require('./whitelist'));
    ngModule.controller('adEventsController', require('./ad_events'));
    ngModule.controller('adEventsDrillController', require('./ad_events_drill'));
    ngModule.controller('cyr3conController', require('./cyr3con'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/ioc_notifications/index.ts
 **/